(() => {
  const setup = root => {
    if (root.dataset.paginationReady) return;
    root.dataset.paginationReady = 'true';
    const states = new WeakMap();
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const widget = root.querySelector('.jdgm-all-reviews-widget');
      if (!widget) return;
      const nativeMore = widget.querySelector('.jdgm-all-reviews-page__load-more');
      if (nativeMore && nativeMore.textContent !== 'Show more reviews') nativeMore.textContent = 'Show more reviews';
      let stagedInActiveBody = false;
      widget.querySelectorAll('.jdgm-all-reviews__body, .jdgm-shop-reviews__body').forEach((body, index) => {
        const cards = [...body.children].filter(el => el.matches('.jdgm-rev'));
        if (!cards.length) return;
        let state = states.get(body);
        const first = cards[0].dataset.reviewId || cards[0].textContent;
        if (!state) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'button namami-reviews-more';
          button.textContent = 'Show more reviews';
          body.id ||= `${root.id}-review-batch-${index}`;
          button.setAttribute('aria-controls', body.id);
          state = { limit: 6, first, button };
          states.set(body, state);
          body.after(button);
          button.addEventListener('click', () => {
            state.limit += 6;
            update();
          });
        }
        if (state.first !== first) { state.limit = 6; state.first = first; }
        cards.forEach((card, i) => card.classList.toggle('namami-review-staged', i >= state.limit));
        const staged = cards.length > state.limit;
        const active = getComputedStyle(body).display !== 'none';
        state.button.hidden = !active || !staged;
        if (active && staged) stagedInActiveBody = true;
      });
      widget.classList.toggle('namami-has-staged-reviews', stagedInActiveBody);
    };
    root.addEventListener('click', event => {
      if (!event.target.closest('.jdgm-all-reviews-page__load-more')) return;
      root.querySelectorAll('.jdgm-all-reviews__body, .jdgm-shop-reviews__body').forEach(body => {
        const state = states.get(body);
        if (state && getComputedStyle(body).display !== 'none') state.limit = [...body.children].filter(el => el.matches('.jdgm-rev')).length + 6;
      });
    });
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    });
    observer.observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['style']});
    update();
  };
  document.querySelectorAll('.namami-reviews-page').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.namami-reviews-page').forEach(setup));
})();
